import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useUserRole } from '../../context/UserRoleContext';
interface NavDropdownProps {
  label: string;
  isActive: boolean;
  onToggle: () => void;
  children: ReactNode;
}
export const NavDropdownItem = ({
  to,
  icon,
  children,
  className = ''
}: {
  to: string;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}) => {
  const dk = useDarkClasses();
  const {
    isReader
  } = useUserRole();
  const baseClasses = 'block w-full text-left px-4 py-2 text-sm flex items-center';
  const lightClasses = isReader ? 'text-gray-700 hover:bg-indigo-50 hover:text-indigo-500' : 'text-gray-700 hover:bg-purple-50 hover:text-purple-600';
  const darkClasses = isReader ? 'text-gray-200 hover:bg-indigo-900/50 hover:text-indigo-500' : 'text-gray-200 hover:bg-purple-900/50 hover:text-purple-600';
  return <Link to={to} className={`${baseClasses} ${dk.isDark ? darkClasses : lightClasses} ${className}`} onClick={e => {
    e.stopPropagation();
  }} data-id="element-2712" data-mp="225atcq6a4ajo">
      {icon && <span className="mr-2" data-id="element-2713" data-mp="1y6344sm3i670">{icon}</span>}
      {children}
    </Link>;
};
const NavDropdown = ({
  label,
  isActive,
  onToggle,
  children
}: NavDropdownProps) => {
  const dk = useDarkClasses();
  const {
    isReader
  } = useUserRole();
  const buttonBaseClasses = 'inline-flex items-center text-sm font-medium border-b-2 h-12 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset whitespace-nowrap';
  const focusRing = isReader ? 'focus-visible:ring-indigo-500' : 'focus-visible:ring-purple-500';
  const buttonLightClasses = isReader ? 'text-gray-700 hover:text-indigo-500 hover:border-indigo-500' : 'text-gray-700 hover:text-purple-600 hover:border-purple-600';
  const buttonDarkClasses = isReader ? 'text-gray-200 hover:text-indigo-500 hover:border-indigo-500' : 'text-gray-200 hover:text-purple-600 hover:border-purple-600';
  const buttonActiveLight = isReader ? 'border-indigo-600 text-indigo-600' : 'border-purple-700 text-purple-700';
  const buttonActiveDark = isReader ? 'border-indigo-600 text-indigo-600' : 'border-purple-700 text-purple-700';
  const buttonInactive = 'border-transparent';
  const dropdownBg = dk.isDark ? 'bg-gray-800 ring-1 ring-gray-700' : 'bg-white ring-1 ring-black ring-opacity-5';
  return <div className="relative" data-dropdown data-id="element-2714" data-mp="6eg5kkwdoayw">
      <button className={`${buttonBaseClasses} ${focusRing} ${dk.isDark ? buttonDarkClasses : buttonLightClasses} ${isActive ? dk.isDark ? buttonActiveDark : buttonActiveLight : buttonInactive}`} onClick={onToggle} aria-expanded={isActive} aria-haspopup="true" data-id="element-2715" data-mp="ai5p2vy742d2">
        {label}
        <ChevronDownIcon className={`ml-1 h-4 w-4 transition-transform ${isActive ? 'rotate-180' : ''}`} data-id="element-2716" data-mp="2h7kaby67fvgw" />
      </button>
      {isActive && <div className={`absolute z-10 left-0 mt-2 w-56 rounded-md shadow-lg ${dropdownBg} focus:outline-none`} role="menu" aria-orientation="vertical" tabIndex={-1} data-id="element-2717" data-mp="2ene9w0gsun53">
          <div className="py-1 max-h-[80vh] overflow-y-auto" role="none" data-id="element-2718" data-mp="2nnj6dfkgg14h">
            {children}
          </div>
        </div>}
    </div>;
};
export default NavDropdown;